<template>
    <div class="base-card__content base-card__shadow filter-vod base-card__zoom" :class="computedClasses">
        <div class="filter-vod__text">{{ caption }}</div>
    </div>
</template>

<script setup lang="ts">
    import { type PropType, type ComputedRef } from "vue";
    import { type FiltersVodCardData } from "../../models";
    import {Strings} from "@/locales/types/enums";
    import { computed } from "vue";
    import { useRoute } from "vue-router";
    import { useI18n } from "vue-i18n";


    const props = defineProps({
        cardData: {
            type: Object as PropType<FiltersVodCardData>,
            required: true
        },
    });

    const route = useRoute();
    const { t } = useI18n();


    const caption = computed(() => {
        const name = `VOD_${props.cardData.getCaption()}`;
        const captionValue: string = t(Strings[name as keyof typeof Strings]).toString();
        return captionValue;
    });
    const computedClasses = computed((): { [key: string]: boolean } => {
        return {
            'filter-vod_active': isActive.value,
            [`filter-vod_${props.cardData.getClass()}`]: true
        };
    });
    const filter: ComputedRef<string | null> = computed(() => route.query.filter ? route.query.filter as string : null);
    const isActive = computed((): boolean => {
        if (filter.value === props.cardData.getFilterType() || !filter.value && props.cardData.getFilterType() === 'All') {
            return true;
        }
        return false;
    });
</script>

<style lang="scss">
    @import url("styles.scss");
</style>